import styled from "@emotion/styled";
import { Card, CardContent, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from "react";

interface ChartCardProps {
    readonly title?: string
    sx?: SxProps<Theme>;
}

const StyledCard = styled(Card)(({ theme }) => ({
    marginRight: "8px",
    marginTop: "12px",
}));

export default function ChartCard({ title, children, sx }: PropsWithChildren<ChartCardProps>) {
    return <StyledCard elevation={1} sx={sx}>
        {/* <CardHeader>{title}</CardHeader> */}
        <CardContent>
            {children}
        </CardContent>
    </StyledCard>
}